import { DataFetchProvider, FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { DoneStep } from '../components/TotpSetupFlow/DoneStep';
import { StartStep } from '../components/TotpSetupFlow/StartStep';
import { VerifyStep } from '../components/TotpSetupFlow/VerifyStep';
import urlBuilder from '../Shared/url-builder';
import { buildAppPath } from '../utils/path-helpers';

const TotpSetupFlow = () => {
  const baseName = buildAppPath('/better_mfa/totp_setup');

  const settingsUrl = urlBuilder.getSettings();

  return (
    <DataFetchProvider>
      <Router>
        <FlowContextProvider basePath={baseName} returnToPath={settingsUrl}>
          <Routes>
            <Route
              path={`${baseName}/start`}
              element={<StepWrapper name="start">{stepProps => <StartStep {...stepProps} />}</StepWrapper>}
            />
            <Route
              path={`${baseName}/verify`}
              element={<StepWrapper name="verify">{stepProps => <VerifyStep {...stepProps} />}</StepWrapper>}
            />
            <Route
              path={`${baseName}/done`}
              element={<StepWrapper name="done">{stepProps => <DoneStep {...stepProps} />}</StepWrapper>}
            />
          </Routes>
        </FlowContextProvider>
      </Router>
    </DataFetchProvider>
  );
};

export default TotpSetupFlow;
